import byteliveApi from './api/byteliveApi';
import { objectToQueryString } from '../utils';

const initialState = {
};

export default (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export const byteliveGetPlaybackUrl = (payload) => {
  return dispatch => {
    return byteliveApi.post(`/bytelive/playbackUrl`, payload).then(data => {
      return data;
    }).catch(error => {
      throw (error);
    });
  };  
}

export const byteliveUploadImage = ({file, name, type}) => {
    return dispatch => {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('folder', type);
      formData.append('name', name);
      return byteliveApi.post(`/bytelive/admin/uploadImage`, formData, true).then((data) => {
        return data; 
      }).catch((error) => {
        throw error;
      });
    };  
};